import clsx from 'clsx';
import { FC, PropsWithChildren, ReactNode } from 'react';

interface Props {
  hero: ReactNode;
  gallery: ReactNode;
  price: ReactNode;
}

export const PdpLayout: FC<PropsWithChildren<Props>> = ({ hero, gallery, price, children }) => {
  return (
    <section className={clsx('c-se--default c-se--white pt-0.5 pb-8', 'header-transparent')}>
      <div className="PdpLayout">
        <div className="PdpLayout-hero">{hero}</div>
        <aside className="PdpLayout-price">
          <div className="PdpLayout-priceContent">{price}</div>
        </aside>
        <div className="PdpLayout-gallery">{gallery}</div>
        <div className="PdpLayout-content">{children}</div>
      </div>
    </section>
  );
};
